export const VERTICAL_BAR_HEIGHT = 24
